import React from "react";
import { Button } from "../../../../ui/components/Button";
import { InvoiceListStatus } from "../../domain";
import { INVOICE_STATUS_OPTIONS } from "../utils/invoiceListStatus";

interface InvoiceStatusFilterPillsProps {
  value: InvoiceListStatus;
  onChange: (value: InvoiceListStatus) => void;
}

export const InvoiceStatusFilterPills: React.FC<InvoiceStatusFilterPillsProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {INVOICE_STATUS_OPTIONS.map((option) => (
        <Button
          key={option.value}
          variant={value === option.value ? "brand-primary" : "neutral-secondary"}
          size="small"
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
};
